export default __webpack_public_path__ + "static/liporedukt-366a129e28f86778e1e2cce7a40ba780.jpg";